export const AUTH_TOKEN = "Access_Token";
export const REFRESH_TOKEN = "Refresh_Token";
export const server_url = process.env.REACT_APP_SERVER_URL;
